import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./categories.css";

const Categories = ({ selectedCategoryId, cl = "" }) => {
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const scrollRef = useRef(null);
  const PAGE_SIZE = 5;

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // ?pagination[page]=${page}&pagination[pageSize]=${PAGE_SIZE}
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/categories`
          // {
          //   headers: {
          //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
          //   },
          // }
        );
        setCategories(res.data.data);
        setPageCount(res.data.meta.pagination.pageCount);
      } catch (error) {
        console.log("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [page]);

  // Check overflow on mount and resize
  // useEffect(() => {
  //   const checkForOverflow = () => {
  //     const el = scrollRef.current;

  //     if (el) {
  //       setShowScrollButtons(el.scrollWidth > el.clientWidth);
  //     }
  //   };

  //   checkForOverflow();
  //   window.addEventListener("resize", checkForOverflow);
  //   return () => window.removeEventListener("resize", checkForOverflow);
  // }, [categories]);
  useEffect(() => {
    const checkForOverflow = () => {
      const el = scrollRef.current;
      if (el) {
        setShowScrollButtons(el.scrollWidth > el.clientWidth);
      }
    };

    // Delay execution to ensure layout is painted
    const timeoutId = setTimeout(checkForOverflow, 100);

    window.addEventListener("resize", checkForOverflow);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", checkForOverflow);
    };
  }, [categories]);

  return (
    <div className="categoryMainContainer w-100">
      <span className="catTitle w-100 ">CATEGORIES</span>

      <div className="categoryScrollWrapper">
        {/* ◀ Scroll Left */}
        {showScrollButtons && (
          <button
            className="scrollButton scrollLeftButton"
            onClick={() => {
              scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
            }}
          >
            <i className="fa-solid fa-caret-left"></i>
          </button>
        )}

        {/* Scrollable container */}
        <div
          className={`gap-2 p-3 categoryContainer ` + cl}
          id="category-scroll"
          ref={scrollRef}
        >
          {/* Add the All option before the categories */}
          {[{ id: "all", name: "All", documentId: "all" }, ...categories].map(
            (category) => (
              <Link
                key={category.id}
                className="link"
                to={
                  category.documentId === "all"
                    ? "/posts"
                    : `/posts?cat=${category.documentId}`
                }
              >
                <button
                  className={`categoryItem ${
                    (selectedCategoryId === "all" &&
                      category.documentId === "all") ||
                    category.documentId === selectedCategoryId
                      ? "activeCategory"
                      : ""
                  }`}
                >
                  {category.name}
                </button>
              </Link>
            )
          )}
        </div>

        {/* ▶ Scroll Right */}
        {showScrollButtons && (
          <button
            className="scrollButton scrollRightButton"
            onClick={() => {
              scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
            }}
          >
            <i className="fa-solid fa-caret-right"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default Categories;
